<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Role" subTitle="Forms" />

    <CreateRole />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateRole from "@/components/Pages/Master/Role/CreateRole.vue";

export default defineComponent({
  name: "CreateRolePage",
  components: {
    PageTitle,
    CreateRole,
  },
});
</script>
